var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { createCtx } from '@cvent/carina-utils';
var _a = __read(createCtx(), 2), useActionsContext = _a[0], ActionsContextProvider = _a[1];
var useActions = function () {
    var footerActions = useActionsContext().footerActions;
    return footerActions;
};
var ActionsProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState({
        start: [],
        end: []
    }), 2), footerActions = _b[0], setFooterActions = _b[1];
    return (_jsx(ActionsContextProvider, __assign({ value: { footerActions: footerActions, setFooterActions: setFooterActions } }, { children: children }), void 0));
};
export { useActions, ActionsProvider, useActionsContext };
